import { logError } from "@/lib/log";
import { toast } from "sonner";

/**
 * Open a Razorpay checkout for a backend-created order.
 * Shared by bill payments (Bills.jsx) and premium plans (Pricing.jsx).
 *
 * @param {object} opts
 * @param {object} opts.order  - { key_id, amount, currency, order_id }
 * @param {string} opts.description
 * @param {object} opts.user   - current user (prefill)
 * @param {(res: object) => Promise<void>} opts.onSuccess - receives razorpay_* fields; must verify server-side
 * @param {() => void} opts.onSettled - called when the flow ends without success (dismiss/failure)
 */
export function openRazorpayCheckout({ order, description, user, onSuccess, onSettled }) {
  if (!window.Razorpay) {
    toast.error("Payment gateway not loaded — check your connection and refresh.");
    onSettled?.();
    return;
  }
  const rzp = new window.Razorpay({
    key: order.key_id,
    amount: order.amount,
    currency: order.currency,
    order_id: order.order_id,
    name: "FinLedger",
    description,
    prefill: { name: user?.name || "", email: user?.email || "" },
    theme: { color: "#1A1F16" },
    handler: (res) => onSuccess(res),
    modal: { ondismiss: () => { toast("Payment cancelled"); onSettled?.(); } },
  });
  rzp.on("payment.failed", (res) => {
    logError("Razorpay payment failed", res.error);
    toast.error(res.error?.description || "Payment failed");
    onSettled?.();
  });
  rzp.open();
}
